import React from "react";
import { Box } from "@mui/material";
import ParentForm from "../Component/ParentForm";

const CreateParent = () => (
  <Box sx={{ p: { xs: 1, md: 2 } }}>
    <ParentForm title="Add Parent" />
  </Box>
);

export default CreateParent;
